<template>
  <a
    :href="getSafeUrl(field.url)"
    class="justify-center items-center px-10 py-3 mt-7 max-w-full text-base uppercase bg-primary rounded-[40px] text-white w-[244px] max-md:px-5"
  >
    {{ field.title }}
  </a>
</template>
<script setup lang="ts">
// Component for call-to-action links with proper URL handling
const props = defineProps({
  field: {
    type: Object,
    required: true,
    default() {
      return {};
    },
  },
});

/**
 * Ensures the URL is valid and handles object URLs properly
 * @param url - URL to sanitize
 * @returns Safe URL string
 */
const getSafeUrl = (url: any): string => {
  // If URL is undefined or null, return # as fallback
  if (!url) return '#';
  
  // Handle object URLs by attempting to use id or returning fallback
  if (typeof url === 'object') {
    // @ts-ignore
    return url.id ? `/${url.id}` : '#';
  }
  
  // Return string URL directly or convert to string as fallback
  return String(url);
};
</script>
